import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface PendingApproval {
  type: 'course_proposal' | 'enrollment' | 'user_request';
  count: number;
  path: string;
}

interface PendingApprovalsWidgetProps {
  approvals: PendingApproval[];
  loading?: boolean;
}

export function PendingApprovalsWidget({ approvals, loading }: PendingApprovalsWidgetProps) {
  const navigate = useNavigate();

  const totalPending = approvals.reduce((sum, item) => sum + item.count, 0);

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5" />
            Pending Approvals
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={totalPending > 0 ? "border-orange-500" : ""}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5" />
          Pending Approvals ({totalPending})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {totalPending === 0 ? (
          <p className="text-sm text-muted-foreground">No pending approvals</p>
        ) : (
          <div className="space-y-2">
            {approvals.map((approval) => (
              approval.count > 0 && (
                <Button
                  key={approval.type}
                  variant="outline"
                  size="sm"
                  className="w-full justify-between"
                  onClick={() => navigate(approval.path)}
                >
                  <span className="capitalize">{approval.type.replace('_', ' ')}</span>
                  <span className="font-bold">{approval.count}</span>
                </Button>
              )
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
